import React from 'react'
import styles from './Rodape.module.css'

export default function Rodape() {
    return (
        <footer className={styles.footer}>
            <h3>
                Desenvolvido por Marcos Maio.
            </h3> 
            
        </footer>
    )
}
